import React, { useState, useCallback } from 'react';
import { Layout, Row, Col, Grid, Modal, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { toolLayoutStyles } from './styles';
import CardLayout from '../../layouts/CardLayout';

const { Content } = Layout;
const { useBreakpoint } = Grid;

interface ToolLayoutProps {
  mainContent: React.ReactNode;
  sidebarContent: React.ReactNode;
  footerContent?: React.ReactNode;
  mobileModalOpen?: boolean;
  onMobileModalOpenChange?: (open: boolean) => void;
  hasModal?: boolean;
}

const ToolLayout: React.FC<ToolLayoutProps> = ({
  hasModal = true,
  mainContent,
  sidebarContent,
  footerContent,
  mobileModalOpen,
  onMobileModalOpenChange,
}) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [internalModalOpen, setInternalModalOpen] = useState(true);

  const isModalOpen = mobileModalOpen !== undefined ? mobileModalOpen : internalModalOpen;
  const setModalOpen = onMobileModalOpenChange || setInternalModalOpen;

  const handleOpenModal = useCallback(() => {
    setModalOpen(true);
  }, [setModalOpen]);

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);

  if (isMobile && hasModal) {
    return (
      <>
        <div style={toolLayoutStyles.mobileHeader}>
          <Button
            type="primary"
            icon={<MenuOutlined />}
            style={toolLayoutStyles.mobileMenuButton}
            onClick={handleOpenModal}
          />
        </div>
        <div style={toolLayoutStyles.mobileContainer}>
          <div style={toolLayoutStyles.mobileContent}>{mainContent}</div>
          <div style={toolLayoutStyles.mobileFooter}>{footerContent}</div>
        </div>

        <Modal
          open={isModalOpen}
          onCancel={handleCloseModal}
          footer={null}
          closable={false}
          width="100vw"
          style={{ top: 0, padding: 0 }}>
          <div style={toolLayoutStyles.mobileModalContainer}>
            <div style={toolLayoutStyles.mobileModalContent}>{sidebarContent}</div>
            <div style={toolLayoutStyles.mobileModalFooter}>
              <Button type="primary" style={toolLayoutStyles.nextButton} onClick={handleCloseModal}>
                Ok
              </Button>
            </div>
          </div>
        </Modal>
      </>
    );
  }

  return (
    <Row style={toolLayoutStyles.desktopRow}>
      <Col span={24} md={14} lg={16} xl={17} flex={1}>
        <Content style={toolLayoutStyles.desktopMainColumn}>{mainContent}</Content>
      </Col>
      <Col span={24} md={10} lg={8} xl={7} flex={1}>
        <CardLayout style={toolLayoutStyles.desktopSidebarCard}>
          <div style={toolLayoutStyles.desktopSidebarContent}>
            <div style={toolLayoutStyles.desktopContent}>{sidebarContent}</div>
            <div style={toolLayoutStyles.desktopFooter}>{footerContent}</div>
          </div>
        </CardLayout>
      </Col>
    </Row>
  );
};

export default ToolLayout;
